<template>
  <tags v-if="isEditable || statement.meta.tags.length"
    v-bind:tags="statement.meta.tags" 
    v-bind:isEditable="isEditable"
    v-bind:model="statement"
    v-on:addTag="addStatementTag()"
    v-on:removeTag="removeStatementTag($event)"
  />
</template>

<script>
  import StatementTags from "./StatementTags.ts";

  export default StatementTags;
</script>
